import React, { Component } from 'react';
import $ from 'jquery';
import './App.scss';
import Header from './components/Header';
import Footer from './components/Footer';
import About from './components/About';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Leadership from './components/Leadership';
import Education from './components/Education';
import Featured from './components/Featured';
import Nav from './components/Nav';

class App extends Component {
  constructor(props) {
    super();
    this.state = {
      foo: 'bar',
      resumeData: {},
      sharedData: {},
    };
  }

  componentDidMount() {
    this.loadSharedData();
    this.loadResumeFromPath();
  }

  loadResumeFromPath() {
    $.ajax({
      url: `res_primaryLanguage.json`,
      dataType: 'json',
      cache: false,
      success: function (data) {
        this.setState({ resumeData: data });
      }.bind(this),
      error: function (xhr, status, err) {
        alert(err);
      },
    });
  }

  loadSharedData() {
    $.ajax({
      url: `portfolio_shared_data.json`,
      dataType: 'json',
      cache: false,
      success: function (data) {
        this.setState({ sharedData: data });
        document.title = `${this.state.sharedData.basic_info.name}`;
      }.bind(this),
      error: function (xhr, status, err) {
        alert(err);
      },
    });
  }

  render() {
    return (
      <div>
        <Nav sharedBasicInfo={this.state.sharedData.basic_info} />
        <Header
          sharedData={this.state.sharedData.basic_info}
          resumeBasicInfo={this.state.resumeData.basic_info}
        />
        <div className='col-xs-12 mx-auto text-center language'>
          <div style={{ display: 'inline' }}>
            <span
              className='iconify language-icon mr-5'
              data-icon='twemoji-flag-for-flag-india'
              data-inline='false'
            ></span>
          </div>
        </div>
        <About
          resumeBasicInfo={this.state.resumeData.basic_info}
          sharedBasicInfo={this.state.sharedData.basic_info}
        />
        <Featured
          resumeFeatured={this.state.resumeData.featured}
          resumeBasicInfo={this.state.resumeData.basic_info}
        />
        <Experience
          resumeExperience={this.state.resumeData.experience}
          resumeBasicInfo={this.state.resumeData.basic_info}
        />
        <Leadership
          resumeLeadership={this.state.resumeData.leadership}
          resumeBasicInfo={this.state.resumeData.basic_info}
        />
        <Education
          resumeEducation={this.state.resumeData.education}
          resumePublication={this.state.resumeData.publication}
          resumeBasicInfo={this.state.resumeData.basic_info}
        />
        <Projects
          resumeProjects={this.state.resumeData.projects}
          resumeBasicInfo={this.state.resumeData.basic_info}
        />
        <Skills
          sharedSkills={this.state.sharedData.skills}
          resumeBasicInfo={this.state.resumeData.basic_info}
        />
        <Footer sharedBasicInfo={this.state.sharedData.basic_info} />
      </div>
    );
  }
}

export default App;
